import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class ECLConfigService {
	private readonly uri: string = `${environment.DO_URL}/v2`;

	constructor(private readonly http: HttpClient) {}

	// Application CRUD operations
	createECLConfig(data: any): Observable<any> {
		return this.http.post(`${this.uri}/ecl-config`, data);
	}

	getECLConfig(): Observable<any> {
		return this.http.get(`${this.uri}/ecl-config`);
	}

	updateECLConfig(data: any): Observable<any> {
		return this.http.put(`${this.uri}/ecl-config/${data.id}`, data);
	}
}
